// @material-ui/core
import { Button } from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";

const styles = theme => ({
  button: {
    "&:hover": {
      textDecoration: "none",
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  },
  marginTop: { marginTop: "30px" },
  fullWidth: { width: `calc(100% - 2 * ${theme.spacing.unit})` },
  icon: { marginLeft: 5, fontSize: "1.25rem" },
  iconTop: { marginTop: 5 }
});

class MainButton extends Component {
  render() {
    const {
      classes,
      fullWidth,
      marginTop,
      colored,
      raised,
      icon,
      children,
      onClick
    } = this.props;

    return (
      <Button
        className={classNames(
          colored,
          !raised && "text",
          marginTop && classes.marginTop,
          this.props.className
        )}
        color="primary"
        variant={raised ? "raised" : "flat"}
        fullWidth={fullWidth}
        classes={{
          root: classNames(classes.button, fullWidth && classes.fullWidth)
        }}
        onClick={onClick}>
        {children}
        <div className={children ? classes.icon : classes.iconTop}>{icon}</div>
      </Button>
    );
  }
}

MainButton.defaultProps = {
  colored: "dark"
};

MainButton.propTypes = {
  classes: PropTypes.object.isRequired,
  colored: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.node,
  raised: PropTypes.bool,
  fulLWidth: PropTypes.bool
};

export default withStyles(styles, { withTheme: true })(MainButton);



// WEBPACK FOOTER //
// ./src/library/button/MainButton/MainButton.js